import config from "@/config"
import http from "@/utils/request"
export default {
	SaveUserInfo: {
	    url: `${config.API_URL}/CiticUserInfo/SaveUserInfo`,
	    name: "保存用户信息",
	    post: async function (data) {
	        return await http.post(this.url, data, {
	            headers: {
	                //'response-status': 401
	            }
	        });
	    }
	},
	DelUserInfo: {
	    url: `${config.API_URL}/CiticUserInfo/DelUserInfo`,
	    name: "删除用户信息",
	    post: async function (data) {
	        return await http.post(this.url, data, {
	            headers: {
	                //'response-status': 401
	            }
	        });
	    }
	},
	BindUserCardInfo: {
	    url: `${config.API_URL}/CiticUserInfo/BindUserCardInfo`,
	    name: "商户绑定银行卡",
	    post: async function (data) {
	        return await http.post(this.url, data, {
	            headers: {
	                //'response-status': 401
	            }
	        });
	    }
	},
	UnBindUserCardInfo: {
	    url: `${config.API_URL}/CiticUserInfo/UnBindUserCardInfo`,
	    name: "商户解除绑定银行卡",
	    post: async function (data) {
	        return await http.post(this.url, data, {
	            headers: {
	                //'response-status': 401
	            }
	        });
	    }
	},
	SetDefulCard: {
	    url: `${config.API_URL}/CiticUserInfo/SetDefulCard`,
	    name: "将银行卡设为默认银行卡",
	    post: async function (data) {
	        return await http.post(this.url, data, {
	            headers: {
	                //'response-status': 401
	            }
	        });
	    }
	},
	GetWithUserInfoList:{
		url: `${config.API_URL}/CiticUserInfo/GetWithUserInfoList`,
		name: "将银行卡设为默认银行卡",
		post: async function (data) {
		    return await http.post(this.url, data, {
		        headers: {
		            //'response-status': 401
		        }
		    });
		}
	},
	OrgWith:{
		url: `${config.API_URL}/CiticOrgWith/OrgWith`,
		name: "将银行卡设为默认银行卡",
		post: async function (data) {
		    return await http.post(this.url, data, {
		        headers: {
		            //'response-status': 401
		        }
		    });
		}
	},
	OrgWithReceipt:{
		url: `${config.API_URL}/CiticOrgWith/OrgWithReceipt`,
		name: "将银行卡设为默认银行卡",
		post: async function (data) {
		    return await http.post(this.url, data, {
		        headers: {
		            //'response-status': 401
		        }
		    });
		}
	},
	OrgWithApply:{
		url: `${config.API_URL}/CiticOrgWith/OrgWithApply`,
		name: "将银行卡设为默认银行卡",
		post: async function (data) {
		    return await http.post(this.url, data, {
		        headers: {
		            //'response-status': 401
		        }
		    });
		}
	},
	OrgTransfer:{
		url: `${config.API_URL}/CiticOrgWith/OrgTransfer`,
		name: "调拨",
		post: async function (data) {
		    return await http.post(this.url, data, {
		        headers: {
		            //'response-status': 401
		        }
		    });
		}
	},
	UpdateSalaryState:{
		url: `${config.API_URL}/CiticUserInfo/UpdateSalaryState`,
		name: "修改工资账户状态",
		post: async function (data) {
		    return await http.post(this.url, data, {
		        headers: {
		            //'response-status': 401
		        }
		    });
		}
	},
}
